export default "__VITE_ASSET__CDVLPEVu__"